import { render, staticRenderFns } from "./HistorialCitas.vue?vue&type=template&id=198a8063&scoped=true&lang=pug"
import script from "./HistorialCitas.vue?vue&type=script&lang=js"
export * from "./HistorialCitas.vue?vue&type=script&lang=js"
import style0 from "./HistorialCitas.vue?vue&type=style&index=0&id=198a8063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198a8063",
  null
  
)

export default component.exports